import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function Field({ label, ...props }) {
  return (
    <div>
      <Label className="text-slate-300 text-xs">{label}</Label>
      <Input {...props} className="mt-1 rounded-none bg-navy border-slate-700 text-sm" />
    </div>
  );
}

export function Panel({ title, children, form }) {
  return (
    <div className="mt-6 grid lg:grid-cols-3 gap-8">
      <div className="lg:col-span-1">
        <div className="bg-navy-paper border border-gold/30 p-6 sticky top-28">
          <h3 className="font-display text-lg font-bold text-white mb-4 flex items-center gap-2"><Plus className="w-4 h-4 text-gold" /> {title}</h3>
          {form}
        </div>
      </div>
      <div className="lg:col-span-2">{children}</div>
    </div>
  );
}

export function DelBtn({ onClick }) {
  return <button onClick={onClick} className="text-slate-500 hover:text-destructive transition-colors" data-testid="admin-delete-btn"><Trash2 className="w-4 h-4" /></button>;
}

export function TextField({ label, value, onChange, textarea, rows = 2 }) {
  return (
    <div>
      <Label className="text-slate-300 text-xs">{label}</Label>
      {textarea ? (
        <Textarea value={value || ""} onChange={(e) => onChange(e.target.value)} rows={rows} className="mt-1 rounded-none bg-navy border-slate-700 text-sm" />
      ) : (
        <Input value={value || ""} onChange={(e) => onChange(e.target.value)} className="mt-1 rounded-none bg-navy border-slate-700 text-sm" />
      )}
    </div>
  );
}
